"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeName = void 0;
let ThemeName;
exports.ThemeName = ThemeName;

(function (ThemeName) {
  ThemeName["papillonDark"] = "PapillonDark";
  ThemeName["papillonLight"] = "PapillonLight";
  ThemeName["mipasaDark"] = "MiPasaDark";
  ThemeName["mipasaLight"] = "MiPasaLight";
  ThemeName["unboundedDark"] = "UnboundedDark";
  ThemeName["unboundedLight"] = "UnboundedLight";
  ThemeName["pasaDark"] = "PasaDark";
  ThemeName["pasaLight"] = "PasaLight";
  ThemeName["dpasaDark"] = "DPasaDark";
  ThemeName["dpasaLight"] = "DPasaLight";
  ThemeName["soikieLight"] = "SoikieLight";
})(ThemeName || (exports.ThemeName = ThemeName = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJUaGVtZU5hbWUiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvdGhlbWVzL3RoZW1lcy50eXBlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBUaGVtZU5hbWUge1xuICBwYXBpbGxvbkRhcmsgPSAnUGFwaWxsb25EYXJrJyxcbiAgcGFwaWxsb25MaWdodCA9ICdQYXBpbGxvbkxpZ2h0JyxcbiAgbWlwYXNhRGFyayA9ICdNaVBhc2FEYXJrJyxcbiAgbWlwYXNhTGlnaHQgPSAnTWlQYXNhTGlnaHQnLFxuICB1bmJvdW5kZWREYXJrID0gJ1VuYm91bmRlZERhcmsnLFxuICB1bmJvdW5kZWRMaWdodCA9ICdVbmJvdW5kZWRMaWdodCcsXG4gIHBhc2FEYXJrID0gJ1Bhc2FEYXJrJyxcbiAgcGFzYUxpZ2h0ID0gJ1Bhc2FMaWdodCcsXG4gIGRwYXNhRGFyayA9ICdEUGFzYURhcmsnLFxuICBkcGFzYUxpZ2h0ID0gJ0RQYXNhTGlnaHQnLFxuICBzb2lraWVMaWdodCA9ICdTb2lraWVMaWdodCcsXG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztJQUFZQSxTOzs7V0FBQUEsUztFQUFBQSxTO0VBQUFBLFM7RUFBQUEsUztFQUFBQSxTO0VBQUFBLFM7RUFBQUEsUztFQUFBQSxTO0VBQUFBLFM7RUFBQUEsUztFQUFBQSxTO0VBQUFBLFM7R0FBQUEsUyx5QkFBQUEsUyJ9